export default "__VITE_ASSET__d56f54bc__"